export default "__VITE_ASSET__00a82277__"